// export { default as cartList } from './cartList/cartList.vue';
export const cartList = (r) => require.ensure([], () => r(require("./cartList/cartList.vue")), "cartList");
